export default "__VITE_ASSET__682db85c__"